import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PlanTier } from "../teams_pb.js";
import { Money } from "../common_pb.js";
var PlanTerm = /* @__PURE__ */ ((PlanTerm2) => {
  PlanTerm2[PlanTerm2["MONTHLY"] = 0] = "MONTHLY";
  PlanTerm2[PlanTerm2["ANNUAL"] = 1] = "ANNUAL";
  return PlanTerm2;
})(PlanTerm || {});
proto3.util.setEnumType(PlanTerm, "alchemy.billing.PlanTerm", [
  { no: 0, name: "MONTHLY" },
  { no: 1, name: "ANNUAL" }
]);
var PlanContractType = /* @__PURE__ */ ((PlanContractType2) => {
  PlanContractType2[PlanContractType2["STANDARD"] = 0] = "STANDARD";
  PlanContractType2[PlanContractType2["RAMPED"] = 1] = "RAMPED";
  PlanContractType2[PlanContractType2["VENTURE"] = 2] = "VENTURE";
  PlanContractType2[PlanContractType2["BUNDLED"] = 3] = "BUNDLED";
  return PlanContractType2;
})(PlanContractType || {});
proto3.util.setEnumType(PlanContractType, "alchemy.billing.PlanContractType", [
  { no: 0, name: "STANDARD" },
  { no: 1, name: "RAMPED" },
  { no: 2, name: "VENTURE" },
  { no: 3, name: "BUNDLED" }
]);
var SubscriptionType = /* @__PURE__ */ ((SubscriptionType2) => {
  SubscriptionType2[SubscriptionType2["CORE"] = 0] = "CORE";
  return SubscriptionType2;
})(SubscriptionType || {});
proto3.util.setEnumType(SubscriptionType, "alchemy.billing.SubscriptionType", [
  { no: 0, name: "CORE" }
]);
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2[InvoiceStatus2["DRAFT"] = 0] = "DRAFT";
  InvoiceStatus2[InvoiceStatus2["ISSUED"] = 1] = "ISSUED";
  InvoiceStatus2[InvoiceStatus2["VOIDED"] = 2] = "VOIDED";
  InvoiceStatus2[InvoiceStatus2["PAID"] = 3] = "PAID";
  InvoiceStatus2[InvoiceStatus2["PAYMENT_FAILED"] = 4] = "PAYMENT_FAILED";
  return InvoiceStatus2;
})(InvoiceStatus || {});
proto3.util.setEnumType(InvoiceStatus, "alchemy.billing.InvoiceStatus", [
  { no: 0, name: "DRAFT" },
  { no: 1, name: "ISSUED" },
  { no: 2, name: "VOIDED" },
  { no: 3, name: "PAID" },
  { no: 4, name: "PAYMENT_FAILED" }
]);
var UsageCapUnit = /* @__PURE__ */ ((UsageCapUnit2) => {
  UsageCapUnit2[UsageCapUnit2["CU"] = 0] = "CU";
  UsageCapUnit2[UsageCapUnit2["DOLLAR"] = 1] = "DOLLAR";
  return UsageCapUnit2;
})(UsageCapUnit || {});
proto3.util.setEnumType(UsageCapUnit, "alchemy.billing.UsageCapUnit", [
  { no: 0, name: "CU" },
  { no: 1, name: "DOLLAR" }
]);
var UsageCapType = /* @__PURE__ */ ((UsageCapType2) => {
  UsageCapType2[UsageCapType2["SOFT_CAP"] = 0] = "SOFT_CAP";
  UsageCapType2[UsageCapType2["HARD_CAP"] = 1] = "HARD_CAP";
  return UsageCapType2;
})(UsageCapType || {});
proto3.util.setEnumType(UsageCapType, "alchemy.billing.UsageCapType", [
  { no: 0, name: "SOFT_CAP" },
  { no: 1, name: "HARD_CAP" }
]);
var UsageCapSource = /* @__PURE__ */ ((UsageCapSource2) => {
  UsageCapSource2[UsageCapSource2["CUSTOM"] = 0] = "CUSTOM";
  UsageCapSource2[UsageCapSource2["PLAN"] = 1] = "PLAN";
  return UsageCapSource2;
})(UsageCapSource || {});
proto3.util.setEnumType(UsageCapSource, "alchemy.billing.UsageCapSource", [
  { no: 0, name: "CUSTOM" },
  { no: 1, name: "PLAN" }
]);
var UsageCapMetric = /* @__PURE__ */ ((UsageCapMetric2) => {
  UsageCapMetric2[UsageCapMetric2["SUPERNODE_CU"] = 0] = "SUPERNODE_CU";
  UsageCapMetric2[UsageCapMetric2["BLAST_CU"] = 1] = "BLAST_CU";
  UsageCapMetric2[UsageCapMetric2["SPONSORED_GAS"] = 2] = "SPONSORED_GAS";
  UsageCapMetric2[UsageCapMetric2["SUPERNODE_ENHANCED_CU"] = 3] = "SUPERNODE_ENHANCED_CU";
  UsageCapMetric2[UsageCapMetric2["ALL_PRODUCTS"] = 100] = "ALL_PRODUCTS";
  return UsageCapMetric2;
})(UsageCapMetric || {});
proto3.util.setEnumType(UsageCapMetric, "alchemy.billing.UsageCapMetric", [
  { no: 0, name: "SUPERNODE_CU" },
  { no: 1, name: "BLAST_CU" },
  { no: 2, name: "SPONSORED_GAS" },
  { no: 3, name: "SUPERNODE_ENHANCED_CU" },
  { no: 100, name: "ALL_PRODUCTS" }
]);
const _MigrateRequest = class _MigrateRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _MigrateRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _MigrateRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _MigrateRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_MigrateRequest, a, b);
  }
};
_MigrateRequest.runtime = proto3;
_MigrateRequest.typeName = "alchemy.billing.MigrateRequest";
_MigrateRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let MigrateRequest = _MigrateRequest;
const _IsMigratedRequest = class _IsMigratedRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _IsMigratedRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _IsMigratedRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _IsMigratedRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_IsMigratedRequest, a, b);
  }
};
_IsMigratedRequest.runtime = proto3;
_IsMigratedRequest.typeName = "alchemy.billing.IsMigratedRequest";
_IsMigratedRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let IsMigratedRequest = _IsMigratedRequest;
const _IsMigratedResponse = class _IsMigratedResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: bool is_migrated = 1;
     */
    this.isMigrated = false;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _IsMigratedResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _IsMigratedResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _IsMigratedResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_IsMigratedResponse, a, b);
  }
};
_IsMigratedResponse.runtime = proto3;
_IsMigratedResponse.typeName = "alchemy.billing.IsMigratedResponse";
_IsMigratedResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "is_migrated",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let IsMigratedResponse = _IsMigratedResponse;
const _TaxId = class _TaxId extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string country = 1;
     */
    this.country = "";
    /**
     * @generated from field: string type = 2;
     */
    this.type = "";
    /**
     * @generated from field: string value = 3;
     */
    this.value = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _TaxId().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _TaxId().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _TaxId().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_TaxId, a, b);
  }
};
_TaxId.runtime = proto3;
_TaxId.typeName = "alchemy.billing.TaxId";
_TaxId.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "country",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "type",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "value",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let TaxId = _TaxId;
const _Customer = class _Customer extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string customer_id = 1;
     */
    this.customerId = "";
    /**
     * @generated from field: string email = 3;
     */
    this.email = "";
    /**
     * @generated from field: repeated string additional_emails = 4;
     */
    this.additionalEmails = [];
    /**
     * @generated from field: string payment_provider_id = 5;
     */
    this.paymentProviderId = "";
    /**
     * @generated from field: string organization = 6;
     */
    this.organization = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _Customer().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _Customer().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _Customer().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_Customer, a, b);
  }
};
_Customer.runtime = proto3;
_Customer.typeName = "alchemy.billing.Customer";
_Customer.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "customer_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "email",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 4, name: "additional_emails", kind: "scalar", T: 9, repeated: true },
  {
    no: 5,
    name: "payment_provider_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "organization",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 7, name: "tax_id", kind: "message", T: TaxId }
]);
let Customer = _Customer;
const _CreateCustomerRequest = class _CreateCustomerRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: string email = 2;
     */
    this.email = "";
    /**
     * @generated from field: repeated string additional_emails = 3;
     */
    this.additionalEmails = [];
    /**
     * @generated from field: string payment_provider_id = 4;
     */
    this.paymentProviderId = "";
    /**
     * @generated from field: string organization = 5;
     */
    this.organization = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateCustomerRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateCustomerRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateCustomerRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateCustomerRequest, a, b);
  }
};
_CreateCustomerRequest.runtime = proto3;
_CreateCustomerRequest.typeName = "alchemy.billing.CreateCustomerRequest";
_CreateCustomerRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "email",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "additional_emails", kind: "scalar", T: 9, repeated: true },
  {
    no: 4,
    name: "payment_provider_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "organization",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let CreateCustomerRequest = _CreateCustomerRequest;
const _CreateCustomerResponse = class _CreateCustomerResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateCustomerResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateCustomerResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateCustomerResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateCustomerResponse, a, b);
  }
};
_CreateCustomerResponse.runtime = proto3;
_CreateCustomerResponse.typeName = "alchemy.billing.CreateCustomerResponse";
_CreateCustomerResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "customer", kind: "message", T: Customer }
]);
let CreateCustomerResponse = _CreateCustomerResponse;
const _GetCustomerRequest = class _GetCustomerRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetCustomerRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetCustomerRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetCustomerRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetCustomerRequest, a, b);
  }
};
_GetCustomerRequest.runtime = proto3;
_GetCustomerRequest.typeName = "alchemy.billing.GetCustomerRequest";
_GetCustomerRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetCustomerRequest = _GetCustomerRequest;
const _GetCustomerResponse = class _GetCustomerResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetCustomerResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetCustomerResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetCustomerResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetCustomerResponse, a, b);
  }
};
_GetCustomerResponse.runtime = proto3;
_GetCustomerResponse.typeName = "alchemy.billing.GetCustomerResponse";
_GetCustomerResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "customer", kind: "message", T: Customer }
]);
let GetCustomerResponse = _GetCustomerResponse;
const _UpdateCustomerRequest = class _UpdateCustomerRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: string email = 2;
     */
    this.email = "";
    /**
     * @generated from field: repeated string additional_emails = 3;
     */
    this.additionalEmails = [];
    /**
     * @generated from field: string payment_provider_id = 5;
     */
    this.paymentProviderId = "";
    /**
     * @generated from field: string organization = 6;
     */
    this.organization = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _UpdateCustomerRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _UpdateCustomerRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _UpdateCustomerRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_UpdateCustomerRequest, a, b);
  }
};
_UpdateCustomerRequest.runtime = proto3;
_UpdateCustomerRequest.typeName = "alchemy.billing.UpdateCustomerRequest";
_UpdateCustomerRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "email",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "additional_emails", kind: "scalar", T: 9, repeated: true },
  { no: 4, name: "tax_id", kind: "message", T: TaxId },
  {
    no: 5,
    name: "payment_provider_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "organization",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let UpdateCustomerRequest = _UpdateCustomerRequest;
const _DeleteCustomerRequest = class _DeleteCustomerRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _DeleteCustomerRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _DeleteCustomerRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _DeleteCustomerRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_DeleteCustomerRequest, a, b);
  }
};
_DeleteCustomerRequest.runtime = proto3;
_DeleteCustomerRequest.typeName = "alchemy.billing.DeleteCustomerRequest";
_DeleteCustomerRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let DeleteCustomerRequest = _DeleteCustomerRequest;
const _Subscription = class _Subscription extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string subscription_id = 1;
     */
    this.subscriptionId = "";
    /**
     * @generated from field: string status = 2;
     */
    this.status = "";
    /**
     * @generated from field: bool auto_collection = 3;
     */
    this.autoCollection = false;
    /**
     * @generated from field: alchemy.billing.SubscriptionType subscription_type = 4;
     */
    this.subscriptionType = 0 /* CORE */;
    /**
     * @generated from field: string team_id = 6;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.teams.PlanTier plan_tier = 7;
     */
    this.planTier = PlanTier.PLAN_TIER_UNSPECIFIED;
    /**
     * @generated from field: alchemy.billing.PlanTerm plan_term = 8;
     */
    this.planTerm = 0 /* MONTHLY */;
    /**
     * @generated from field: alchemy.billing.PlanContractType plan_contract_type = 9;
     */
    this.planContractType = 0 /* STANDARD */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _Subscription().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _Subscription().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _Subscription().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_Subscription, a, b);
  }
};
_Subscription.runtime = proto3;
_Subscription.typeName = "alchemy.billing.Subscription";
_Subscription.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "subscription_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "status",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "auto_collection",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  { no: 4, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
  { no: 5, name: "plan_start_timestamp", kind: "message", T: Timestamp },
  {
    no: 6,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 7, name: "plan_tier", kind: "enum", T: proto3.getEnumType(PlanTier) },
  { no: 8, name: "plan_term", kind: "enum", T: proto3.getEnumType(PlanTerm) },
  { no: 9, name: "plan_contract_type", kind: "enum", T: proto3.getEnumType(PlanContractType) }
]);
let Subscription = _Subscription;
const _CreateSubscriptionRequest = class _CreateSubscriptionRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.teams.PlanTier tier = 2;
     */
    this.tier = PlanTier.PLAN_TIER_UNSPECIFIED;
    /**
     * @generated from field: alchemy.billing.PlanTerm term = 3;
     */
    this.term = 0 /* MONTHLY */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateSubscriptionRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateSubscriptionRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateSubscriptionRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateSubscriptionRequest, a, b);
  }
};
_CreateSubscriptionRequest.runtime = proto3;
_CreateSubscriptionRequest.typeName = "alchemy.billing.CreateSubscriptionRequest";
_CreateSubscriptionRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "tier", kind: "enum", T: proto3.getEnumType(PlanTier) },
  { no: 3, name: "term", kind: "enum", T: proto3.getEnumType(PlanTerm) }
]);
let CreateSubscriptionRequest = _CreateSubscriptionRequest;
const _CreateSubscriptionResponse = class _CreateSubscriptionResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string subscription_id = 1;
     */
    this.subscriptionId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateSubscriptionResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateSubscriptionResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateSubscriptionResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateSubscriptionResponse, a, b);
  }
};
_CreateSubscriptionResponse.runtime = proto3;
_CreateSubscriptionResponse.typeName = "alchemy.billing.CreateSubscriptionResponse";
_CreateSubscriptionResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "subscription_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let CreateSubscriptionResponse = _CreateSubscriptionResponse;
const _GetSubscriptionRequest = class _GetSubscriptionRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string subscription_id = 1;
     */
    this.subscriptionId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionRequest, a, b);
  }
};
_GetSubscriptionRequest.runtime = proto3;
_GetSubscriptionRequest.typeName = "alchemy.billing.GetSubscriptionRequest";
_GetSubscriptionRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "subscription_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetSubscriptionRequest = _GetSubscriptionRequest;
const _GetSubscriptionResponse = class _GetSubscriptionResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionResponse, a, b);
  }
};
_GetSubscriptionResponse.runtime = proto3;
_GetSubscriptionResponse.typeName = "alchemy.billing.GetSubscriptionResponse";
_GetSubscriptionResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "subscription", kind: "message", T: Subscription }
]);
let GetSubscriptionResponse = _GetSubscriptionResponse;
const _GetSubscriptionByTeamAndTypeRequest = class _GetSubscriptionByTeamAndTypeRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.billing.SubscriptionType subscription_type = 2;
     */
    this.subscriptionType = 0 /* CORE */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionByTeamAndTypeRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionByTeamAndTypeRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionByTeamAndTypeRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionByTeamAndTypeRequest, a, b);
  }
};
_GetSubscriptionByTeamAndTypeRequest.runtime = proto3;
_GetSubscriptionByTeamAndTypeRequest.typeName = "alchemy.billing.GetSubscriptionByTeamAndTypeRequest";
_GetSubscriptionByTeamAndTypeRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) }
]);
let GetSubscriptionByTeamAndTypeRequest = _GetSubscriptionByTeamAndTypeRequest;
const _GetSubscriptionByTeamAndTypeResponse = class _GetSubscriptionByTeamAndTypeResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionByTeamAndTypeResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionByTeamAndTypeResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionByTeamAndTypeResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionByTeamAndTypeResponse, a, b);
  }
};
_GetSubscriptionByTeamAndTypeResponse.runtime = proto3;
_GetSubscriptionByTeamAndTypeResponse.typeName = "alchemy.billing.GetSubscriptionByTeamAndTypeResponse";
_GetSubscriptionByTeamAndTypeResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "subscription", kind: "message", T: Subscription }
]);
let GetSubscriptionByTeamAndTypeResponse = _GetSubscriptionByTeamAndTypeResponse;
const _GetSubscriptionDetailsFromDbRequest = class _GetSubscriptionDetailsFromDbRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.billing.SubscriptionType subscription_type = 2;
     */
    this.subscriptionType = 0 /* CORE */;
    /**
     * @generated from field: alchemy.billing.UsageCapMetric metric = 3;
     */
    this.metric = 0 /* SUPERNODE_CU */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionDetailsFromDbRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionDetailsFromDbRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionDetailsFromDbRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionDetailsFromDbRequest, a, b);
  }
};
_GetSubscriptionDetailsFromDbRequest.runtime = proto3;
_GetSubscriptionDetailsFromDbRequest.typeName = "alchemy.billing.GetSubscriptionDetailsFromDbRequest";
_GetSubscriptionDetailsFromDbRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
  { no: 3, name: "metric", kind: "enum", T: proto3.getEnumType(UsageCapMetric) }
]);
let GetSubscriptionDetailsFromDbRequest = _GetSubscriptionDetailsFromDbRequest;
const _GetSubscriptionDetailsFromDbResponse = class _GetSubscriptionDetailsFromDbResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.billing.SubscriptionType subscription_type = 2;
     */
    this.subscriptionType = 0 /* CORE */;
    /**
     * @generated from field: alchemy.teams.PlanTier tier = 3;
     */
    this.tier = PlanTier.PLAN_TIER_UNSPECIFIED;
    /**
     * @generated from field: alchemy.billing.PlanTerm term = 4;
     */
    this.term = 0 /* MONTHLY */;
    /**
     * @generated from field: double price_per_cu = 5;
     */
    this.pricePerCu = 0;
    /**
     * @generated from field: int64 base_allocation_cu = 6;
     */
    this.baseAllocationCu = protoInt64.zero;
    /**
     * @generated from field: bool auto_scale = 7;
     */
    this.autoScale = false;
    /**
     * @generated from field: alchemy.billing.UsageCapMetric metric = 9;
     */
    this.metric = 0 /* SUPERNODE_CU */;
    /**
     * @generated from field: alchemy.billing.PlanContractType plan_contract_type = 10;
     */
    this.planContractType = 0 /* STANDARD */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionDetailsFromDbResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionDetailsFromDbResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionDetailsFromDbResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionDetailsFromDbResponse, a, b);
  }
};
_GetSubscriptionDetailsFromDbResponse.runtime = proto3;
_GetSubscriptionDetailsFromDbResponse.typeName = "alchemy.billing.GetSubscriptionDetailsFromDbResponse";
_GetSubscriptionDetailsFromDbResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
  { no: 3, name: "tier", kind: "enum", T: proto3.getEnumType(PlanTier) },
  { no: 4, name: "term", kind: "enum", T: proto3.getEnumType(PlanTerm) },
  {
    no: 5,
    name: "price_per_cu",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  },
  {
    no: 6,
    name: "base_allocation_cu",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 7,
    name: "auto_scale",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  { no: 8, name: "plan_start_timestamp", kind: "message", T: Timestamp },
  { no: 9, name: "metric", kind: "enum", T: proto3.getEnumType(UsageCapMetric) },
  { no: 10, name: "plan_contract_type", kind: "enum", T: proto3.getEnumType(PlanContractType) }
]);
let GetSubscriptionDetailsFromDbResponse = _GetSubscriptionDetailsFromDbResponse;
const _GetProductUsageSnapshotsRequest = class _GetProductUsageSnapshotsRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * If empty, the response will also be empty.
     * If `ALL_PRODUCTS` is included, all metrics will be returned.
     * If specific metrics are listed, only those will be returned.
     * If `ALL_PRODUCTS` is combined with others, `ALL_PRODUCTS` takes precedence.
     *
     * @generated from field: repeated alchemy.billing.UsageCapMetric products = 2;
     */
    this.products = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetProductUsageSnapshotsRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetProductUsageSnapshotsRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetProductUsageSnapshotsRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetProductUsageSnapshotsRequest, a, b);
  }
};
_GetProductUsageSnapshotsRequest.runtime = proto3;
_GetProductUsageSnapshotsRequest.typeName = "alchemy.billing.GetProductUsageSnapshotsRequest";
_GetProductUsageSnapshotsRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "products", kind: "enum", T: proto3.getEnumType(UsageCapMetric), repeated: true }
]);
let GetProductUsageSnapshotsRequest = _GetProductUsageSnapshotsRequest;
const _GetProductUsageSnapshotsResponse = class _GetProductUsageSnapshotsResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: repeated alchemy.billing.ProductUsageSnapshot product_usage_snapshot = 7;
     */
    this.productUsageSnapshot = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetProductUsageSnapshotsResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetProductUsageSnapshotsResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetProductUsageSnapshotsResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetProductUsageSnapshotsResponse, a, b);
  }
};
_GetProductUsageSnapshotsResponse.runtime = proto3;
_GetProductUsageSnapshotsResponse.typeName = "alchemy.billing.GetProductUsageSnapshotsResponse";
_GetProductUsageSnapshotsResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 7, name: "product_usage_snapshot", kind: "message", T: ProductUsageSnapshot, repeated: true },
  { no: 6, name: "plan_start_timestamp", kind: "message", T: Timestamp }
]);
let GetProductUsageSnapshotsResponse = _GetProductUsageSnapshotsResponse;
const _ProductUsageSnapshot = class _ProductUsageSnapshot extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: alchemy.billing.UsageCapMetric product = 1;
     */
    this.product = 0 /* SUPERNODE_CU */;
    /**
     * @generated from field: bool autoscale = 6;
     */
    this.autoscale = false;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _ProductUsageSnapshot().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _ProductUsageSnapshot().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _ProductUsageSnapshot().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_ProductUsageSnapshot, a, b);
  }
};
_ProductUsageSnapshot.runtime = proto3;
_ProductUsageSnapshot.typeName = "alchemy.billing.ProductUsageSnapshot";
_ProductUsageSnapshot.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "product", kind: "enum", T: proto3.getEnumType(UsageCapMetric) },
  { no: 2, name: "base_allocation", kind: "message", T: Money },
  { no: 4, name: "used_amount", kind: "message", T: Money },
  { no: 5, name: "used_amount_in_dollars", kind: "message", T: Money },
  { no: 7, name: "unpaid_used_balance", kind: "message", T: Money },
  { no: 8, name: "base_limit", kind: "message", T: Money },
  { no: 9, name: "credit_available_for_current_billing_period", kind: "message", T: Money },
  { no: 10, name: "credit_remaining_now", kind: "message", T: Money },
  {
    no: 6,
    name: "autoscale",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let ProductUsageSnapshot = _ProductUsageSnapshot;
const _UpdateSubscriptionRequest = class _UpdateSubscriptionRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string subscription_id = 1;
     */
    this.subscriptionId = "";
    /**
     * @generated from oneof alchemy.billing.UpdateSubscriptionRequest.auto_collection_value
     */
    this.autoCollectionValue = { case: void 0 };
    /**
     * @generated from oneof alchemy.billing.UpdateSubscriptionRequest.auto_scale_value
     */
    this.autoScaleValue = { case: void 0 };
    /**
     * @generated from field: alchemy.billing.UsageCapMetric metric = 4;
     */
    this.metric = 0 /* SUPERNODE_CU */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _UpdateSubscriptionRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _UpdateSubscriptionRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _UpdateSubscriptionRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_UpdateSubscriptionRequest, a, b);
  }
};
_UpdateSubscriptionRequest.runtime = proto3;
_UpdateSubscriptionRequest.typeName = "alchemy.billing.UpdateSubscriptionRequest";
_UpdateSubscriptionRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "subscription_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "auto_collection", kind: "scalar", T: 8, oneof: "auto_collection_value" },
  { no: 3, name: "auto_scale", kind: "scalar", T: 8, oneof: "auto_scale_value" },
  { no: 4, name: "metric", kind: "enum", T: proto3.getEnumType(UsageCapMetric) }
]);
let UpdateSubscriptionRequest = _UpdateSubscriptionRequest;
const _DeleteSubscriptionRequest = class _DeleteSubscriptionRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string subscription_id = 1;
     */
    this.subscriptionId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _DeleteSubscriptionRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _DeleteSubscriptionRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _DeleteSubscriptionRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_DeleteSubscriptionRequest, a, b);
  }
};
_DeleteSubscriptionRequest.runtime = proto3;
_DeleteSubscriptionRequest.typeName = "alchemy.billing.DeleteSubscriptionRequest";
_DeleteSubscriptionRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "subscription_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let DeleteSubscriptionRequest = _DeleteSubscriptionRequest;
const _GetSubscriptionsRequest = class _GetSubscriptionsRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionsRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionsRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionsRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionsRequest, a, b);
  }
};
_GetSubscriptionsRequest.runtime = proto3;
_GetSubscriptionsRequest.typeName = "alchemy.billing.GetSubscriptionsRequest";
_GetSubscriptionsRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetSubscriptionsRequest = _GetSubscriptionsRequest;
const _GetSubscriptionsResponse = class _GetSubscriptionsResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.billing.Subscription subscriptions = 1;
     */
    this.subscriptions = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionsResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionsResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionsResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionsResponse, a, b);
  }
};
_GetSubscriptionsResponse.runtime = proto3;
_GetSubscriptionsResponse.typeName = "alchemy.billing.GetSubscriptionsResponse";
_GetSubscriptionsResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "subscriptions", kind: "message", T: Subscription, repeated: true }
]);
let GetSubscriptionsResponse = _GetSubscriptionsResponse;
const _SetTeamGasBaseLimitRequest = class _SetTeamGasBaseLimitRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string request_id = 1;
     */
    this.requestId = "";
    /**
     * @generated from field: string team_id = 2;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SetTeamGasBaseLimitRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SetTeamGasBaseLimitRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SetTeamGasBaseLimitRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_SetTeamGasBaseLimitRequest, a, b);
  }
};
_SetTeamGasBaseLimitRequest.runtime = proto3;
_SetTeamGasBaseLimitRequest.typeName = "alchemy.billing.SetTeamGasBaseLimitRequest";
_SetTeamGasBaseLimitRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "request_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "base_limit_amount", kind: "message", T: Money }
]);
let SetTeamGasBaseLimitRequest = _SetTeamGasBaseLimitRequest;
const _SetTeamGasBaseLimitResponse = class _SetTeamGasBaseLimitResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SetTeamGasBaseLimitResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SetTeamGasBaseLimitResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SetTeamGasBaseLimitResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_SetTeamGasBaseLimitResponse, a, b);
  }
};
_SetTeamGasBaseLimitResponse.runtime = proto3;
_SetTeamGasBaseLimitResponse.typeName = "alchemy.billing.SetTeamGasBaseLimitResponse";
_SetTeamGasBaseLimitResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "product_usage_snapshot", kind: "message", T: ProductUsageSnapshot }
]);
let SetTeamGasBaseLimitResponse = _SetTeamGasBaseLimitResponse;
const _GetGasManagerUsageSnapshotRequest = class _GetGasManagerUsageSnapshotRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetGasManagerUsageSnapshotRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetGasManagerUsageSnapshotRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetGasManagerUsageSnapshotRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetGasManagerUsageSnapshotRequest, a, b);
  }
};
_GetGasManagerUsageSnapshotRequest.runtime = proto3;
_GetGasManagerUsageSnapshotRequest.typeName = "alchemy.billing.GetGasManagerUsageSnapshotRequest";
_GetGasManagerUsageSnapshotRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetGasManagerUsageSnapshotRequest = _GetGasManagerUsageSnapshotRequest;
const _GetGasManagerUsageSnapshotResponse = class _GetGasManagerUsageSnapshotResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetGasManagerUsageSnapshotResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetGasManagerUsageSnapshotResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetGasManagerUsageSnapshotResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetGasManagerUsageSnapshotResponse, a, b);
  }
};
_GetGasManagerUsageSnapshotResponse.runtime = proto3;
_GetGasManagerUsageSnapshotResponse.typeName = "alchemy.billing.GetGasManagerUsageSnapshotResponse";
_GetGasManagerUsageSnapshotResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "product_usage_snapshot", kind: "message", T: ProductUsageSnapshot }
]);
let GetGasManagerUsageSnapshotResponse = _GetGasManagerUsageSnapshotResponse;
const _AddGasPredepositRequest = class _AddGasPredepositRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string request_id = 1;
     */
    this.requestId = "";
    /**
     * @generated from field: string team_id = 2;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _AddGasPredepositRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _AddGasPredepositRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _AddGasPredepositRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_AddGasPredepositRequest, a, b);
  }
};
_AddGasPredepositRequest.runtime = proto3;
_AddGasPredepositRequest.typeName = "alchemy.billing.AddGasPredepositRequest";
_AddGasPredepositRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "request_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "predeposit_amount", kind: "message", T: Money }
]);
let AddGasPredepositRequest = _AddGasPredepositRequest;
const _AddGasPredepositResponse = class _AddGasPredepositResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _AddGasPredepositResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _AddGasPredepositResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _AddGasPredepositResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_AddGasPredepositResponse, a, b);
  }
};
_AddGasPredepositResponse.runtime = proto3;
_AddGasPredepositResponse.typeName = "alchemy.billing.AddGasPredepositResponse";
_AddGasPredepositResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "product_usage_snapshot", kind: "message", T: ProductUsageSnapshot }
]);
let AddGasPredepositResponse = _AddGasPredepositResponse;
const _GetSponsorStopListRequest = class _GetSponsorStopListRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated string team_ids = 1;
     */
    this.teamIds = [];
    /**
     * @generated from field: repeated string reasons = 2;
     */
    this.reasons = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSponsorStopListRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSponsorStopListRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSponsorStopListRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSponsorStopListRequest, a, b);
  }
};
_GetSponsorStopListRequest.runtime = proto3;
_GetSponsorStopListRequest.typeName = "alchemy.billing.GetSponsorStopListRequest";
_GetSponsorStopListRequest.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "team_ids", kind: "scalar", T: 9, repeated: true },
  { no: 2, name: "reasons", kind: "scalar", T: 9, repeated: true }
]);
let GetSponsorStopListRequest = _GetSponsorStopListRequest;
const _GetSponsorStopListResponse = class _GetSponsorStopListResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.billing.SponsorshipStopReason stop_reasons = 1;
     */
    this.stopReasons = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSponsorStopListResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSponsorStopListResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSponsorStopListResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSponsorStopListResponse, a, b);
  }
};
_GetSponsorStopListResponse.runtime = proto3;
_GetSponsorStopListResponse.typeName = "alchemy.billing.GetSponsorStopListResponse";
_GetSponsorStopListResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "stop_reasons", kind: "message", T: SponsorshipStopReason, repeated: true }
]);
let GetSponsorStopListResponse = _GetSponsorStopListResponse;
const _SponsorshipStopReason = class _SponsorshipStopReason extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: string reason = 2;
     */
    this.reason = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SponsorshipStopReason().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SponsorshipStopReason().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SponsorshipStopReason().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_SponsorshipStopReason, a, b);
  }
};
_SponsorshipStopReason.runtime = proto3;
_SponsorshipStopReason.typeName = "alchemy.billing.SponsorshipStopReason";
_SponsorshipStopReason.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "reason",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let SponsorshipStopReason = _SponsorshipStopReason;
const _CreateGasManagerCreditsRequest = class _CreateGasManagerCreditsRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: double predeposit_amount = 2;
     */
    this.predepositAmount = 0;
    /**
     * @generated from field: string description = 3;
     */
    this.description = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateGasManagerCreditsRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateGasManagerCreditsRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateGasManagerCreditsRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateGasManagerCreditsRequest, a, b);
  }
};
_CreateGasManagerCreditsRequest.runtime = proto3;
_CreateGasManagerCreditsRequest.typeName = "alchemy.billing.CreateGasManagerCreditsRequest";
_CreateGasManagerCreditsRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "predeposit_amount",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  },
  {
    no: 3,
    name: "description",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let CreateGasManagerCreditsRequest = _CreateGasManagerCreditsRequest;
const _CreateGasManagerCreditsResponse = class _CreateGasManagerCreditsResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: bool success = 1;
     */
    this.success = false;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateGasManagerCreditsResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateGasManagerCreditsResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateGasManagerCreditsResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateGasManagerCreditsResponse, a, b);
  }
};
_CreateGasManagerCreditsResponse.runtime = proto3;
_CreateGasManagerCreditsResponse.typeName = "alchemy.billing.CreateGasManagerCreditsResponse";
_CreateGasManagerCreditsResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "success",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let CreateGasManagerCreditsResponse = _CreateGasManagerCreditsResponse;
const _GetGasManagerUsageAndCreditsRequest = class _GetGasManagerUsageAndCreditsRequest extends Message {
  constructor(data) {
    super();
    /**
     * Used for debugging purposes. ASK BEFORE USING IT IN PROD
     *
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetGasManagerUsageAndCreditsRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetGasManagerUsageAndCreditsRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetGasManagerUsageAndCreditsRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetGasManagerUsageAndCreditsRequest, a, b);
  }
};
_GetGasManagerUsageAndCreditsRequest.runtime = proto3;
_GetGasManagerUsageAndCreditsRequest.typeName = "alchemy.billing.GetGasManagerUsageAndCreditsRequest";
_GetGasManagerUsageAndCreditsRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "start_date", kind: "message", T: Timestamp, opt: true },
  { no: 3, name: "end_date", kind: "message", T: Timestamp, opt: true }
]);
let GetGasManagerUsageAndCreditsRequest = _GetGasManagerUsageAndCreditsRequest;
const _GetGasManagerUsageAndCreditsResponse = class _GetGasManagerUsageAndCreditsResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: double current_month_usage = 1;
     */
    this.currentMonthUsage = 0;
    /**
     * @generated from field: double remaining_credits = 2;
     */
    this.remainingCredits = 0;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetGasManagerUsageAndCreditsResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetGasManagerUsageAndCreditsResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetGasManagerUsageAndCreditsResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetGasManagerUsageAndCreditsResponse, a, b);
  }
};
_GetGasManagerUsageAndCreditsResponse.runtime = proto3;
_GetGasManagerUsageAndCreditsResponse.typeName = "alchemy.billing.GetGasManagerUsageAndCreditsResponse";
_GetGasManagerUsageAndCreditsResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "current_month_usage",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  },
  {
    no: 2,
    name: "remaining_credits",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  }
]);
let GetGasManagerUsageAndCreditsResponse = _GetGasManagerUsageAndCreditsResponse;
const _UpdatePlanRequest = class _UpdatePlanRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.teams.PlanTier new_tier = 2;
     */
    this.newTier = PlanTier.PLAN_TIER_UNSPECIFIED;
    /**
     * @generated from field: alchemy.billing.PlanTerm new_term = 3;
     */
    this.newTerm = 0 /* MONTHLY */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _UpdatePlanRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _UpdatePlanRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _UpdatePlanRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_UpdatePlanRequest, a, b);
  }
};
_UpdatePlanRequest.runtime = proto3;
_UpdatePlanRequest.typeName = "alchemy.billing.UpdatePlanRequest";
_UpdatePlanRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "new_tier", kind: "enum", T: proto3.getEnumType(PlanTier) },
  { no: 3, name: "new_term", kind: "enum", T: proto3.getEnumType(PlanTerm) }
]);
let UpdatePlanRequest = _UpdatePlanRequest;
const _GetInvoicesRequest = class _GetInvoicesRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: repeated alchemy.billing.InvoiceStatus statuses = 2;
     */
    this.statuses = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetInvoicesRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetInvoicesRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetInvoicesRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetInvoicesRequest, a, b);
  }
};
_GetInvoicesRequest.runtime = proto3;
_GetInvoicesRequest.typeName = "alchemy.billing.GetInvoicesRequest";
_GetInvoicesRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "statuses", kind: "enum", T: proto3.getEnumType(InvoiceStatus), repeated: true }
]);
let GetInvoicesRequest = _GetInvoicesRequest;
const _GetInvoicesResponse = class _GetInvoicesResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.billing.Invoice invoices = 1;
     */
    this.invoices = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetInvoicesResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetInvoicesResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetInvoicesResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetInvoicesResponse, a, b);
  }
};
_GetInvoicesResponse.runtime = proto3;
_GetInvoicesResponse.typeName = "alchemy.billing.GetInvoicesResponse";
_GetInvoicesResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "invoices", kind: "message", T: Invoice, repeated: true }
]);
let GetInvoicesResponse = _GetInvoicesResponse;
const _CreateInvoiceRequest = class _CreateInvoiceRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: string currency = 2;
     */
    this.currency = "";
    /**
     * @generated from field: double net_terms = 4;
     */
    this.netTerms = 0;
    /**
     * @generated from field: repeated alchemy.billing.InvoiceLineItem line_items = 5;
     */
    this.lineItems = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateInvoiceRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateInvoiceRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateInvoiceRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateInvoiceRequest, a, b);
  }
};
_CreateInvoiceRequest.runtime = proto3;
_CreateInvoiceRequest.typeName = "alchemy.billing.CreateInvoiceRequest";
_CreateInvoiceRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "currency",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "invoice_date", kind: "message", T: Timestamp },
  {
    no: 4,
    name: "net_terms",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  },
  { no: 5, name: "line_items", kind: "message", T: InvoiceLineItem, repeated: true }
]);
let CreateInvoiceRequest = _CreateInvoiceRequest;
const _CreateInvoiceResponse = class _CreateInvoiceResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateInvoiceResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateInvoiceResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateInvoiceResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateInvoiceResponse, a, b);
  }
};
_CreateInvoiceResponse.runtime = proto3;
_CreateInvoiceResponse.typeName = "alchemy.billing.CreateInvoiceResponse";
_CreateInvoiceResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "invoice", kind: "message", T: Invoice }
]);
let CreateInvoiceResponse = _CreateInvoiceResponse;
const _Invoice = class _Invoice extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string hosted_url = 1;
     */
    this.hostedUrl = "";
    /**
     * @generated from field: string pdf_url = 2;
     */
    this.pdfUrl = "";
    /**
     * @generated from field: alchemy.billing.InvoiceStatus status = 3;
     */
    this.status = 0 /* DRAFT */;
    /**
     * @generated from field: string credit_card_brand = 4;
     */
    this.creditCardBrand = "";
    /**
     * @generated from field: string credit_card_last_four = 5;
     */
    this.creditCardLastFour = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _Invoice().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _Invoice().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _Invoice().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_Invoice, a, b);
  }
};
_Invoice.runtime = proto3;
_Invoice.typeName = "alchemy.billing.Invoice";
_Invoice.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "hosted_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "pdf_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(InvoiceStatus) },
  {
    no: 4,
    name: "credit_card_brand",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "credit_card_last_four",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 6, name: "issued_at", kind: "message", T: Timestamp },
  { no: 7, name: "paid_at", kind: "message", T: Timestamp },
  { no: 8, name: "due_date", kind: "message", T: Timestamp },
  { no: 9, name: "invoice_date", kind: "message", T: Timestamp },
  { no: 50, name: "subtotal", kind: "message", T: Money },
  { no: 51, name: "total", kind: "message", T: Money },
  { no: 52, name: "amount_due", kind: "message", T: Money }
]);
let Invoice = _Invoice;
const _InvoiceLineItem = class _InvoiceLineItem extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string name = 1;
     */
    this.name = "";
    /**
     * @generated from field: string item_id = 2;
     */
    this.itemId = "";
    /**
     * @generated from field: string model_type = 3;
     */
    this.modelType = "";
    /**
     * @generated from field: double quantity = 6;
     */
    this.quantity = 0;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _InvoiceLineItem().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _InvoiceLineItem().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _InvoiceLineItem().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_InvoiceLineItem, a, b);
  }
};
_InvoiceLineItem.runtime = proto3;
_InvoiceLineItem.typeName = "alchemy.billing.InvoiceLineItem";
_InvoiceLineItem.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "item_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "model_type",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 4, name: "start_date", kind: "message", T: Timestamp },
  { no: 5, name: "end_date", kind: "message", T: Timestamp },
  {
    no: 6,
    name: "quantity",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  },
  { no: 7, name: "unit_config", kind: "message", T: InvoiceLineItem_UnitConfig }
]);
let InvoiceLineItem = _InvoiceLineItem;
const _InvoiceLineItem_UnitConfig = class _InvoiceLineItem_UnitConfig extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string unit_amount = 1;
     */
    this.unitAmount = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _InvoiceLineItem_UnitConfig().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _InvoiceLineItem_UnitConfig().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _InvoiceLineItem_UnitConfig().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_InvoiceLineItem_UnitConfig, a, b);
  }
};
_InvoiceLineItem_UnitConfig.runtime = proto3;
_InvoiceLineItem_UnitConfig.typeName = "alchemy.billing.InvoiceLineItem.UnitConfig";
_InvoiceLineItem_UnitConfig.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "unit_amount",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let InvoiceLineItem_UnitConfig = _InvoiceLineItem_UnitConfig;
const _UsageCap = class _UsageCap extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int32 id = 1;
     */
    this.id = 0;
    /**
     * @generated from field: string team_id = 2;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.billing.UsageCapType type = 3;
     */
    this.type = 0 /* SOFT_CAP */;
    /**
     * @generated from field: alchemy.billing.UsageCapUnit unit = 4;
     */
    this.unit = 0 /* CU */;
    /**
     * @generated from field: alchemy.billing.UsageCapSource source = 5;
     */
    this.source = 0 /* CUSTOM */;
    /**
     * @generated from field: int64 threshold = 6;
     */
    this.threshold = protoInt64.zero;
    /**
     * @generated from field: alchemy.billing.UsageCapMetric metric = 8;
     */
    this.metric = 0 /* SUPERNODE_CU */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _UsageCap().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _UsageCap().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _UsageCap().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_UsageCap, a, b);
  }
};
_UsageCap.runtime = proto3;
_UsageCap.typeName = "alchemy.billing.UsageCap";
_UsageCap.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 2,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(UsageCapType) },
  { no: 4, name: "unit", kind: "enum", T: proto3.getEnumType(UsageCapUnit) },
  { no: 5, name: "source", kind: "enum", T: proto3.getEnumType(UsageCapSource) },
  {
    no: 6,
    name: "threshold",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  { no: 7, name: "created_at", kind: "message", T: Timestamp },
  { no: 8, name: "metric", kind: "enum", T: proto3.getEnumType(UsageCapMetric) }
]);
let UsageCap = _UsageCap;
const _CreateUsageCapRequest = class _CreateUsageCapRequest extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateUsageCapRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateUsageCapRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateUsageCapRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateUsageCapRequest, a, b);
  }
};
_CreateUsageCapRequest.runtime = proto3;
_CreateUsageCapRequest.typeName = "alchemy.billing.CreateUsageCapRequest";
_CreateUsageCapRequest.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "usage_cap", kind: "message", T: UsageCap }
]);
let CreateUsageCapRequest = _CreateUsageCapRequest;
const _CreateUsageCapResponse = class _CreateUsageCapResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CreateUsageCapResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CreateUsageCapResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CreateUsageCapResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CreateUsageCapResponse, a, b);
  }
};
_CreateUsageCapResponse.runtime = proto3;
_CreateUsageCapResponse.typeName = "alchemy.billing.CreateUsageCapResponse";
_CreateUsageCapResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "usage_cap", kind: "message", T: UsageCap }
]);
let CreateUsageCapResponse = _CreateUsageCapResponse;
const _GetMonthlySpendLimitRequest = class _GetMonthlySpendLimitRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetMonthlySpendLimitRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetMonthlySpendLimitRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetMonthlySpendLimitRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetMonthlySpendLimitRequest, a, b);
  }
};
_GetMonthlySpendLimitRequest.runtime = proto3;
_GetMonthlySpendLimitRequest.typeName = "alchemy.billing.GetMonthlySpendLimitRequest";
_GetMonthlySpendLimitRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetMonthlySpendLimitRequest = _GetMonthlySpendLimitRequest;
const _GetMonthlySpendLimitResponse = class _GetMonthlySpendLimitResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int32 maximum_spend_limit = 1;
     */
    this.maximumSpendLimit = 0;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetMonthlySpendLimitResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetMonthlySpendLimitResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetMonthlySpendLimitResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetMonthlySpendLimitResponse, a, b);
  }
};
_GetMonthlySpendLimitResponse.runtime = proto3;
_GetMonthlySpendLimitResponse.typeName = "alchemy.billing.GetMonthlySpendLimitResponse";
_GetMonthlySpendLimitResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "maximum_spend_limit",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
let GetMonthlySpendLimitResponse = _GetMonthlySpendLimitResponse;
const _GetUnpaidUsageRequest = class _GetUnpaidUsageRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetUnpaidUsageRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetUnpaidUsageRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetUnpaidUsageRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetUnpaidUsageRequest, a, b);
  }
};
_GetUnpaidUsageRequest.runtime = proto3;
_GetUnpaidUsageRequest.typeName = "alchemy.billing.GetUnpaidUsageRequest";
_GetUnpaidUsageRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetUnpaidUsageRequest = _GetUnpaidUsageRequest;
const _GetUnpaidUsageResponse = class _GetUnpaidUsageResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 unpaid_usage_amount = 1;
     */
    this.unpaidUsageAmount = protoInt64.zero;
    /**
     * @generated from field: int32 unpaid_invoices_count = 2;
     */
    this.unpaidInvoicesCount = 0;
    /**
     * @generated from field: int64 pending_invoice_amount = 3;
     */
    this.pendingInvoiceAmount = protoInt64.zero;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetUnpaidUsageResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetUnpaidUsageResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetUnpaidUsageResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetUnpaidUsageResponse, a, b);
  }
};
_GetUnpaidUsageResponse.runtime = proto3;
_GetUnpaidUsageResponse.typeName = "alchemy.billing.GetUnpaidUsageResponse";
_GetUnpaidUsageResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "unpaid_usage_amount",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "unpaid_invoices_count",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "pending_invoice_amount",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
let GetUnpaidUsageResponse = _GetUnpaidUsageResponse;
const _GetUsageCapsRequest = class _GetUsageCapsRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: alchemy.billing.UsageCapType type = 2;
     */
    this.type = 0 /* SOFT_CAP */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetUsageCapsRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetUsageCapsRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetUsageCapsRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetUsageCapsRequest, a, b);
  }
};
_GetUsageCapsRequest.runtime = proto3;
_GetUsageCapsRequest.typeName = "alchemy.billing.GetUsageCapsRequest";
_GetUsageCapsRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(UsageCapType) }
]);
let GetUsageCapsRequest = _GetUsageCapsRequest;
const _GetUsageCapsResponse = class _GetUsageCapsResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.billing.UsageCap usage_caps = 1;
     */
    this.usageCaps = [];
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetUsageCapsResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetUsageCapsResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetUsageCapsResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetUsageCapsResponse, a, b);
  }
};
_GetUsageCapsResponse.runtime = proto3;
_GetUsageCapsResponse.typeName = "alchemy.billing.GetUsageCapsResponse";
_GetUsageCapsResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "usage_caps", kind: "message", T: UsageCap, repeated: true }
]);
let GetUsageCapsResponse = _GetUsageCapsResponse;
const _CapTeamRequest = class _CapTeamRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: bool should_cap = 2;
     */
    this.shouldCap = false;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CapTeamRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CapTeamRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CapTeamRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_CapTeamRequest, a, b);
  }
};
_CapTeamRequest.runtime = proto3;
_CapTeamRequest.typeName = "alchemy.billing.CapTeamRequest";
_CapTeamRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "should_cap",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let CapTeamRequest = _CapTeamRequest;
const _SetMonthlySpendLimitRequest = class _SetMonthlySpendLimitRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    /**
     * @generated from field: int32 maximum_spend_limit = 2;
     */
    this.maximumSpendLimit = 0;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SetMonthlySpendLimitRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SetMonthlySpendLimitRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SetMonthlySpendLimitRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_SetMonthlySpendLimitRequest, a, b);
  }
};
_SetMonthlySpendLimitRequest.runtime = proto3;
_SetMonthlySpendLimitRequest.typeName = "alchemy.billing.SetMonthlySpendLimitRequest";
_SetMonthlySpendLimitRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "maximum_spend_limit",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
let SetMonthlySpendLimitRequest = _SetMonthlySpendLimitRequest;
const _SetMonthlySpendLimitResponse = class _SetMonthlySpendLimitResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: bool success = 1;
     */
    this.success = false;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SetMonthlySpendLimitResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SetMonthlySpendLimitResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SetMonthlySpendLimitResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_SetMonthlySpendLimitResponse, a, b);
  }
};
_SetMonthlySpendLimitResponse.runtime = proto3;
_SetMonthlySpendLimitResponse.typeName = "alchemy.billing.SetMonthlySpendLimitResponse";
_SetMonthlySpendLimitResponse.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "success",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let SetMonthlySpendLimitResponse = _SetMonthlySpendLimitResponse;
const _UpdateUsageCapRequest = class _UpdateUsageCapRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int32 id = 1;
     */
    this.id = 0;
    /**
     * @generated from field: int64 threshold = 2;
     */
    this.threshold = protoInt64.zero;
    /**
     * @generated from field: alchemy.billing.UsageCapUnit unit = 3;
     */
    this.unit = 0 /* CU */;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _UpdateUsageCapRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _UpdateUsageCapRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _UpdateUsageCapRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_UpdateUsageCapRequest, a, b);
  }
};
_UpdateUsageCapRequest.runtime = proto3;
_UpdateUsageCapRequest.typeName = "alchemy.billing.UpdateUsageCapRequest";
_UpdateUsageCapRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 2,
    name: "threshold",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  { no: 3, name: "unit", kind: "enum", T: proto3.getEnumType(UsageCapUnit) }
]);
let UpdateUsageCapRequest = _UpdateUsageCapRequest;
const _UpdateUsageCapResponse = class _UpdateUsageCapResponse extends Message {
  constructor(data) {
    super();
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _UpdateUsageCapResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _UpdateUsageCapResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _UpdateUsageCapResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_UpdateUsageCapResponse, a, b);
  }
};
_UpdateUsageCapResponse.runtime = proto3;
_UpdateUsageCapResponse.typeName = "alchemy.billing.UpdateUsageCapResponse";
_UpdateUsageCapResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "usage_cap", kind: "message", T: UsageCap }
]);
let UpdateUsageCapResponse = _UpdateUsageCapResponse;
const _DeleteUsageCapRequest = class _DeleteUsageCapRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int32 id = 1;
     */
    this.id = 0;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _DeleteUsageCapRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _DeleteUsageCapRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _DeleteUsageCapRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_DeleteUsageCapRequest, a, b);
  }
};
_DeleteUsageCapRequest.runtime = proto3;
_DeleteUsageCapRequest.typeName = "alchemy.billing.DeleteUsageCapRequest";
_DeleteUsageCapRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
let DeleteUsageCapRequest = _DeleteUsageCapRequest;
const _SubscriptionSchedulePhase = class _SubscriptionSchedulePhase extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string external_plan_id = 1;
     */
    this.externalPlanId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SubscriptionSchedulePhase().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SubscriptionSchedulePhase().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SubscriptionSchedulePhase().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_SubscriptionSchedulePhase, a, b);
  }
};
_SubscriptionSchedulePhase.runtime = proto3;
_SubscriptionSchedulePhase.typeName = "alchemy.billing.SubscriptionSchedulePhase";
_SubscriptionSchedulePhase.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "external_plan_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "start_date", kind: "message", T: Timestamp },
  { no: 3, name: "end_date", kind: "message", T: Timestamp },
  { no: 4, name: "created_at", kind: "message", T: Timestamp }
]);
let SubscriptionSchedulePhase = _SubscriptionSchedulePhase;
const _GetSubscriptionSchedulesRequest = class _GetSubscriptionSchedulesRequest extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: string team_id = 1;
     */
    this.teamId = "";
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionSchedulesRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionSchedulesRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionSchedulesRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionSchedulesRequest, a, b);
  }
};
_GetSubscriptionSchedulesRequest.runtime = proto3;
_GetSubscriptionSchedulesRequest.typeName = "alchemy.billing.GetSubscriptionSchedulesRequest";
_GetSubscriptionSchedulesRequest.fields = proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let GetSubscriptionSchedulesRequest = _GetSubscriptionSchedulesRequest;
const _GetSubscriptionSchedulesResponse = class _GetSubscriptionSchedulesResponse extends Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.billing.SubscriptionSchedulePhase subscription_schedule_phases = 1;
     */
    this.subscriptionSchedulePhases = [];
    /**
     * @generated from field: bool has_scheduled_change = 2;
     */
    this.hasScheduledChange = false;
    proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetSubscriptionSchedulesResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetSubscriptionSchedulesResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetSubscriptionSchedulesResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return proto3.util.equals(_GetSubscriptionSchedulesResponse, a, b);
  }
};
_GetSubscriptionSchedulesResponse.runtime = proto3;
_GetSubscriptionSchedulesResponse.typeName = "alchemy.billing.GetSubscriptionSchedulesResponse";
_GetSubscriptionSchedulesResponse.fields = proto3.util.newFieldList(() => [
  { no: 1, name: "subscription_schedule_phases", kind: "message", T: SubscriptionSchedulePhase, repeated: true },
  {
    no: 2,
    name: "has_scheduled_change",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let GetSubscriptionSchedulesResponse = _GetSubscriptionSchedulesResponse;
export {
  AddGasPredepositRequest,
  AddGasPredepositResponse,
  CapTeamRequest,
  CreateCustomerRequest,
  CreateCustomerResponse,
  CreateGasManagerCreditsRequest,
  CreateGasManagerCreditsResponse,
  CreateInvoiceRequest,
  CreateInvoiceResponse,
  CreateSubscriptionRequest,
  CreateSubscriptionResponse,
  CreateUsageCapRequest,
  CreateUsageCapResponse,
  Customer,
  DeleteCustomerRequest,
  DeleteSubscriptionRequest,
  DeleteUsageCapRequest,
  GetCustomerRequest,
  GetCustomerResponse,
  GetGasManagerUsageAndCreditsRequest,
  GetGasManagerUsageAndCreditsResponse,
  GetGasManagerUsageSnapshotRequest,
  GetGasManagerUsageSnapshotResponse,
  GetInvoicesRequest,
  GetInvoicesResponse,
  GetMonthlySpendLimitRequest,
  GetMonthlySpendLimitResponse,
  GetProductUsageSnapshotsRequest,
  GetProductUsageSnapshotsResponse,
  GetSponsorStopListRequest,
  GetSponsorStopListResponse,
  GetSubscriptionByTeamAndTypeRequest,
  GetSubscriptionByTeamAndTypeResponse,
  GetSubscriptionDetailsFromDbRequest,
  GetSubscriptionDetailsFromDbResponse,
  GetSubscriptionRequest,
  GetSubscriptionResponse,
  GetSubscriptionSchedulesRequest,
  GetSubscriptionSchedulesResponse,
  GetSubscriptionsRequest,
  GetSubscriptionsResponse,
  GetUnpaidUsageRequest,
  GetUnpaidUsageResponse,
  GetUsageCapsRequest,
  GetUsageCapsResponse,
  Invoice,
  InvoiceLineItem,
  InvoiceLineItem_UnitConfig,
  InvoiceStatus,
  IsMigratedRequest,
  IsMigratedResponse,
  MigrateRequest,
  PlanContractType,
  PlanTerm,
  ProductUsageSnapshot,
  SetMonthlySpendLimitRequest,
  SetMonthlySpendLimitResponse,
  SetTeamGasBaseLimitRequest,
  SetTeamGasBaseLimitResponse,
  SponsorshipStopReason,
  Subscription,
  SubscriptionSchedulePhase,
  SubscriptionType,
  TaxId,
  UpdateCustomerRequest,
  UpdatePlanRequest,
  UpdateSubscriptionRequest,
  UpdateUsageCapRequest,
  UpdateUsageCapResponse,
  UsageCap,
  UsageCapMetric,
  UsageCapSource,
  UsageCapType,
  UsageCapUnit
};
